import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { rememberReturnTo } from '../utils/returnTo';

/**
 * The single place an unauthenticated visit turns into a trip to /login.
 * Records the URL the user was actually asking for first, so signing in
 * returns them to it (see `utils/returnTo`).
 */
const RedirectToLogin: React.FC = () => {
  const location = useLocation();

  // Written during render rather than from an effect, on purpose: <Navigate>
  // performs its navigation from its own effect, and a child's effects run
  // before its parent's — so an effect here would record the destination
  // only after we had already left it. The write is an idempotent,
  // URL-keyed sessionStorage set with no React state involved, which makes
  // it safe to repeat under StrictMode's double render.
  rememberReturnTo(location);

  return <Navigate to="/login" replace />;
};

export default RedirectToLogin;
